"use client";

import React from "react";
import Image from "next/image";
import GTMLink from "../../Atoms/GTMLink";
import { GoogleTagManagerEvents } from "../../../common";
import TypographyMontserrat from "../../Atoms/TypographyMontserrat";

const SideNavbarSections = ({ links, onClick }) => {
    return (
        <div className="flex flex-col mt-10">
            {links?.map(({ link, text, src }) => (
                <GTMLink
                    event={GoogleTagManagerEvents.navigationInteractions}
                    place={"header"}
                    menuName={"header navigation menu"}
                    href={link || ""}
                    passHref
                    onClick={onClick}
                    prefetch
                >
                    <div className="flex flex-col justify-between py-3 min-w-52 cursor-pointer ">
                        <div className="relative w-[208px] h-[115px]">
                            <Image
                                fill
                                src={src}
                                alt={`${text} image`}
                                className="object-cover"
                                sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                            />
                        </div>
                        <TypographyMontserrat
                            size={"sm"}
                            fontWeight={"medium"}
                            text={text}
                            customStyle={"!capitalize"}
                        />
                    </div>
                </GTMLink>
            ))}
        </div>
    );
};

export default SideNavbarSections;
